module.exports = __webpack_public_path__ + "img/icon-right.2844d6c5.png";